import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { loadModule, logger, fill, isThenable } from '@sentry/utils';
/** Tracing integration for Apollo */

var Apollo = /*#__PURE__*/function () {
  function Apollo() {
    _classCallCheck(this, Apollo);

    Apollo.prototype.__init.call(this);
  }
  /**
   * @inheritDoc
   */


  _createClass(Apollo, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Apollo.id;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "setupOnce",
    value: function setupOnce(_, getCurrentHub) {
      var pkg = loadModule('apollo-server-core');

      if (!pkg) {
        logger.error('Apollo Integration was unable to require apollo-server-core package.');
        return;
      }
      /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */


      fill(pkg.ApolloServerBase.prototype, 'constructSchema', function (orig) {
        return function () {
          var resolvers = Array.isArray(this.config.resolvers) ? this.config.resolvers : [this.config.resolvers];
          this.config.resolvers = resolvers.map(function (model) {
            Object.keys(model).forEach(function (resolverGroupName) {
              Object.keys(model[resolverGroupName]).forEach(function (resolverName) {
                if (typeof model[resolverGroupName][resolverName] !== 'function') {
                  return;
                }

                wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
              });
            });
            return model;
          });
          return orig.call(this);
        };
      });
    }
  }], [{
    key: "__initStatic",
    value: function __initStatic() {
      this.id = 'Apollo';
    }
  }]);

  return Apollo;
}();

Apollo.__initStatic();
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */


function wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
  fill(model[resolverGroupName], resolverName, function (orig) {
    return function () {
      var scope = getCurrentHub().getScope();

      var parentSpan = _optionalChain([scope, 'optionalAccess', function (_2) {
        return _2.getSpan;
      }, 'call', function (_3) {
        return _3();
      }]);

      var span = _optionalChain([parentSpan, 'optionalAccess', function (_4) {
        return _4.startChild;
      }, 'call', function (_5) {
        return _5({
          description: "".concat(resolverGroupName, ".").concat(resolverName),
          op: 'db.graphql.apollo'
        });
      }]);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var rv = orig.call.apply(orig, [this].concat(args));

      if (isThenable(rv)) {
        return rv.then(function (res) {
          _optionalChain([span, 'optionalAccess', function (_6) {
            return _6.finish;
          }, 'call', function (_7) {
            return _7();
          }]);

          return res;
        });
      }

      _optionalChain([span, 'optionalAccess', function (_8) {
        return _8.finish;
      }, 'call', function (_9) {
        return _9();
      }]);

      return rv;
    };
  });
}

export { Apollo };